import axios from "axios";

const url = process.env.REACT_APP_SERVER_URL;

// ── Inventory Items ──────────────────────────────────────

export const getInventoryItems = async (category = null) => {
    try {
        const params = category ? `?category=${category}` : "";
        const response = await axios.get(`${url}/inventory/items${params}`);
        if (response && response.data) return response.data;
        return [];
    } catch (error) {
        console.log(error);
    }
};

export const getInventoryItemByBarcode = async (barcode) => {
    try {
        const response = await axios.get(`${url}/inventory/items/barcode/${barcode}`);
        if (response && response.data && response.data.length > 0) return response.data[0];
        return null;
    } catch (error) {
        console.log(error);
    }
};

export const createInventoryItem = async (data) => {
    try {
        const response = await axios.post(`${url}/inventory/items`, data);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log(error);
    }
};

export const updateInventoryItem = async (id, data) => {
    try {
        const response = await axios.patch(`${url}/inventory/items/${id}`, data);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log(error);
    }
};

// ── Inventory Logs ───────────────────────────────────────

export const getInventoryLogs = async (filters = {}) => {
    try {
        const params = new URLSearchParams(filters).toString();
        const response = await axios.get(`${url}/inventory/logs${params ? `?${params}` : ""}`);
        if (response && response.data) return response.data;
        return [];
    } catch (error) {
        console.log(error);
    }
};

export const getInventoryLogsByItemId = async (itemId) => {
    try {
        const response = await axios.get(`${url}/inventory/logs/item/${itemId}`);
        if (response && response.data) return response.data;
        return [];
    } catch (error) {
        console.log(error);
    }
};

export const getCurrentStock = async (itemId) => {
    try {
        const response = await axios.get(`${url}/inventory/stock/${itemId}`);
        if (response && response.data && response.data.length > 0) return response.data[0];
        return null;
    } catch (error) {
        console.log(error);
    }
};

export const createInventoryLog = async (data) => {
    try {
        const response = await axios.post(`${url}/inventory/logs`, data);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log(error);
    }
};